﻿import CardForm from '../components/card-form';

class ForgotPasswordForm extends CardForm {
    initialize(params: URLSearchParams) {
        // Set the app id from the searchparams
        this.$elements.values['clientId'].value = params.get('app');

        super.initialize(params);
    }

    async onSubmitSuccess() {
        // Redirect to wherever
        window.location.assign('./message-sent.html');
    }
}


// Bootstrap this page
const form = new ForgotPasswordForm(document.querySelector('form'));
const params = new URLSearchParams(window.location.search);
form.initialize(params);

